import * as React from "react";

import { BaseControl } from "VSS/Controls";


import { TeamProjectReference } from "TFS/Core/Contracts";

import { ProjectSelectorMenu, ProjectSelectorMenuOptions } from "VersionControl/Scripts/Controls/ProjectSelectorMenu";

export interface ProjectSelectorProps {
    currentProject: TeamProjectReference;
    onProjectChange: (project: TeamProjectReference) => void;
    className?: string;
    title?: string;
    fullPopupWidth?: boolean;
}

export class ProjectPicker extends React.PureComponent<ProjectSelectorProps, {}> {
    private _projectSelectorMenu: ProjectSelectorMenu;
    private _container: HTMLElement;

    public componentDidMount(): void {
        this._projectSelectorMenu = BaseControl.enhance(
            ProjectSelectorMenu,
            this._container,
            {
                projectId: null,
                projectInfo: undefined,
                showRepositoryActions: false,
                showItemIcons: true,
                tfvcRepository: null,
                initialSelectedItem: this.props.currentProject,
                onItemChanged: this._onItemSelected,
                initialRepositories: [],
                setPopupWidthToMatchMenu: this.props.fullPopupWidth,
            } as ProjectSelectorMenuOptions) as ProjectSelectorMenu;

        if (this.props.title) {
            this._container.title = this.props.title;
        }
    }

    public componentWillUnmount(): void {
        if (this._projectSelectorMenu) {
            this._projectSelectorMenu.dispose();
            this._projectSelectorMenu = null;
        }
    }

    public render(): JSX.Element {
        return <div ref={this._storeContainerRef} role={"combobox"} className={"vc-project-picker"} />;
    }

    private _storeContainerRef = (elem: HTMLElement) => {
        this._container = elem;
    }

    private _onItemSelected = (project: TeamProjectReference) => {
        if (this.props.onProjectChange) {
            this.props.onProjectChange(project);
        }
    }
}
